import type { RouteRecordRaw } from 'vue-router'
import { adminBaseRoutePath } from '/@/router/static/adminBase'
import { getSubDomain } from '../utils/axios';
// import { memberCenterBaseRoutePath } from '/@/router/static/memberCenterBase'

const pageTitle = (name: string): string => {
	return `pagesTitle.${name}`
}
// 地区数据
const areas = [
	// { code: 'tz', name: '台州首页', description: '打造台州地区AI技术创新中心', color: 'from-blue-500 to-indigo-600' },
	{ code: 'tz', name: '首页', description: '打造台州地区AI技术创新中心', color: 'from-blue-500 to-indigo-600' },
	{ code: 'hz', name: '杭州首页', description: '助力杭州数字经济高质量发展', color: 'from-cyan-500 to-blue-600', status: 'developing' },
	{ code: 'nb', name: '宁波首页', description: '赋能宁波制造业智能化升级', color: 'from-indigo-500 to-purple-600', status: 'developing' },
	{ code: 'wz', name: '温州首页', description: '推动温州传统产业智能化转型', color: 'from-green-500 to-teal-600', status: 'developing' },
	{ code: 'sx', name: '绍兴首页', description: '助力绍兴产业数字化升级', color: 'from-orange-500 to-amber-600', status: 'developing' },
	{ code: 'jx', name: '嘉兴首页', description: '促进嘉兴数字经济创新发展', color: 'from-pink-500 to-rose-600', status: 'developing' },
	{ code: 'hz2', name: '湖州首页', description: '赋能湖州绿色智能制造升级', color: 'from-emerald-500 to-green-600', status: 'developing' },
	{ code: 'jh', name: '金华首页', description: '推动金华产业数字化转型', color: 'from-amber-500 to-yellow-600', status: 'developing' },
	{ code: 'ls', name: '丽水首页', description: '助力丽水生态产业智能化升级', color: 'from-emerald-500 to-teal-600', status: 'developing' },
	{ code: 'qz', name: '衢州首页', description: '赋能衢州数字经济发展', color: 'from-violet-500 to-purple-600', status: 'developing' },
	{ code: 'zs', name: '舟山首页', description: '助力舟山海洋经济智能化转型', color: 'from-sky-500 to-cyan-600', status: 'developing' },
];


/*
 * 静态路由
 * 自动加载 ./static 目录的所有文件，并 push 到以下数组
 */
const staticRoutes: Array<RouteRecordRaw> = [
	{
		// 首页
		path: '/',
		name: '/',
		component: () => import('/@/layouts/frontend/chat.vue'),
		meta: {
			title: pageTitle('home'),
		},
		// redirect: '/writing',
		redirect: '/home',
		children: [
			{
				path: 'writing',
				name: 'writing',
				component: () => import('/@/views/frontend/apply/writing.vue'),
				meta: {
					title: '解析招标文件',
				},
			},
			{
				path: 'pluginCenter',
				name: 'pluginCenter',
				component: () => import('/@/views/frontend/apply/pluginCenter.vue'),
				meta: {
					title: '功能插件中心',
				},
			},
			{
				path: 'bidDelegation',
				name: 'bidDelegation',
				component: () => import('/@/views/frontend/apply/bidDelegation.vue'),
				meta: {
					title: '委托下单',
				},
			},
			{
				path: 'videoGenerate',
				name: 'videoGenerate',
				component: () => import('/@/views/frontend/apply/videoGenerate/videoGenerate.vue'),
				meta: {
					title: '智创生视频',
				},
			},
			{
				path: 'WebOffice',
				name: 'WebOffice',
				component: () => import('/@/components/apply/WebOffice/Demo.vue'),
				meta: {
					title: '方案列表',
				},
			},
			// {
			// 	path: 'WangEditor',
			// 	name: 'WangEditor',
			// 	component: () => import('/@/components/apply/WangEditor/demo.vue'),
			// 	meta: {
			// 		title: '方案列表',
			// 	},
			// },
			// {
			// 	path: 'docxtest',
			// 	name: 'docxtest',
			// 	component: () => import('/@/views/test/DocxTest.vue'),
			// 	meta: {
			// 		title: 'DOCX 功能测试',
			// 	},
			// },
			// {
			// 	path: 'docximport',
			// 	name: 'docximport',
			// 	component: () => import('/@/views/test/DocxImportTest.vue'),
			// 	meta: {
			// 		title: 'DOCX 高级导入测试',
			// 	},
			// },
			{
				path: 'selectCompany',
				name: 'selectCompany',
				component: () => import('/@/views/frontend/apply/selectCompany.vue'),
				meta: {
					title: '配置投标参数',
				},
			},
			{
				path: 'gantt',
				name: 'gantt',
				component: () => import('/@/views/frontend/apply/gantt/ganttPage.vue'),
				meta: {
					title: '横道图生成',
				},
			},
			{
				path: 'ganttPreview',
				name: 'ganttPreview',
				component: () => import('/@/views/frontend/apply/gantt/ganttEdit.vue'),
				meta: {
					title: '横道图预览',
				},
			},
			{
				path: 'engineeringQuantity',
				name: 'engineeringQuantity',
				component: () => import('/@/views/frontend/apply/engineeringQuantity/engineeringQuantity.vue'),
				meta: {
					title: '工程量清单解析',
				},
			},
			{
				path: 'imageGenerate/textToImage',
				name: 'textToImage',
				component: () => import('/@/views/frontend/apply/imageGenerate/imageGenerate.vue'),
				meta: {
					title: '工程效果图',
				},
			},
			{
					path: 'imageGenerate/imageToImage',
					name: 'imageToImage',
					component: () => import('/@/views/frontend/apply/imageGenerate/imageGenerate.vue'),
					meta: {
						title: '工程仿图',
					},
				},
				{
					path: 'imageGenerate/textToImage2',
					name: 'textToImage2',
					component: () => import('/@/views/frontend/apply/imageGenerate/imageGenerate2.vue'),
					meta: {
						title: '工程效果图2',
					},
				},
			{
				path: 'fillBid',
				name: 'fillBid',
				component: () => import('/@/views/frontend/apply/fillBid.vue'),
				meta: {
					title: '填充投标信息',
				},
			},
			// {
			// 	path: '/createScheme',
			// 	name: 'createScheme',
			// 	component: () => import('/@/views/frontend/apply/createScheme.vue'),
			// 	meta: {
			// 		title: '创建方案',
			// 	},
			// },
			// {
			// 	path: '/bidReview',
			// 	name: 'bidReview',
			// 	component: () => import('/@/views/frontend/apply/bidReview.vue'),
			// 	meta: {
			// 		title: '投标评分',
			// 	},
			// },
			{
				path: '/startWriting',
				name: 'startWriting',
				component: () => import('/@/views/frontend/apply/startWriting.vue'),
				meta: {
					title: '写作',
				},
			},
			{
				path: '/home',
				name: 'home',
				component: () => import('/@/views/frontend/apply/home.vue'),
				meta: {
					// title: '首页',
					title: areas.find(item => item.code === getSubDomain())?.name || '首页',
				},
			},
			// {
			// 	path: '/unite',
			// 	name: 'unite',
			// 	component: () => import('/@/views/frontend/apply/unite.vue'),
			// 	meta: {
			// 		title: '联合协作',
			// 	},
			// },
			{
				path: '/payment_agreement',
				name: 'payment_agreement',
				component: () => import('/@/components/apply/paymentAgreement.vue'),
				meta: {
					title: '服务购买协议',
				},
			},
			{
				path: '/data_agreement',
				name: 'data_agreement',
				component: () => import('/@/components/apply/dataAgreement.vue'),
				meta: {
					title: '数据使用提前告知及授权协议',
				},
			},
			{
				path: '/disclaimer_agreement',
				name: 'disclaimer_agreement',
				component: () => import('/@/components/apply/disclaimerAgreement.vue'),
				meta: {
					title: '数据使用提前告知及授权协议',
				},
			},
			{
				path: '/checkAnalyzeTender',
				name: 'checkAnalyzeTender',
				component: () => import('/@/views/frontend/apply/checkAnalyzeTender.vue'),
				meta: {
					title: '查看分析招标文件',
				},
			},
			{
				path: '/checkAnalyzeTender2',
				name: 'checkAnalyzeTender2',
				component: () => import('/@/views/frontend/apply/checkAnalyzeTender2.vue'),
				meta: {
					title: '查看分析招标文件',
				},
			},

			// {
			// 	path: '/test',
			// 	name: 'test',
			// 	component: () => import('/@/views/frontend/chat/test.vue'),
			// 	meta: {
			// 		title: '查看分析招标文件',
			// 	},
			// },
			{
				path: '/users',
				name: 'users',
				redirect: '/users/user',
				component: () => import('/@/views/frontend/chat/users.vue'),
				meta: {
					title: '个人中心',
				},
				children: [
					{
						path: 'user',
						name: 'user',
						component: () => import('/@/views/frontend/apply/member/index.vue'),
						meta: {
							title: '个人中心',
						},
					},
					{
						path: 'authentication',
						name: 'authentication',
						component: () => import('/@/views/frontend/apply/member/authentication.vue'),
						meta: {
							title: '企业认证',
						},
					},
					{
						path: 'share',
						name: 'share',
						component: () => import('/@/views/frontend/apply/member/share.vue'),
						meta: {
							title: '我的邀请',
						},
					},
					{
						path: 'schemes',
						name: 'schemes',
						component: () => import('/@/views/frontend/apply/member/myBid.vue'),
						meta: {
							title: '我的方案',
						},
					},
					{
						path: 'order',
						name: 'order',
						component: () => import('/@/views/frontend/apply/member/userAllOrder.vue'),
						meta: {
							title: '我的订单',
						},
					},
					// {
					// 	path: 'withdraw',
					// 	name: 'withdraw',
					// 	component: () => import('/@/views/frontend/apply/member/withdraw.vue'),
					// 	meta: {
					// 		title: '我的订单',
					// 	},
					// },
					// {
					// 	path: 'recharge',
					// 	name: 'recharge',
					// 	component: () => import('/@/layouts/frontend/components/chat/users/recharge.vue'),
					// 	meta: {
					// 		title: '我的订单',
					// 	},
					// },
					// {
					// 	path: 'setting',
					// 	name: 'setting',
					// 	component: () => import('/@/views/frontend/apply/member/accountSetting.vue'),
					// 	meta: {
					// 		title: '账号设置',
					// 	},
					// },
					// {
					// 	path: 'uniteSeller',
					// 	name: 'uniteSeller',
					// 	component: () => import('/@/views/frontend/apply/member/uniteSeller.vue'),
					// 	meta: {
					// 		title: '联合写作商',
					// 	},
					// },
					// {
					// 	path: 'preparers',
					// 	name: 'preparers',
					// 	component: () => import('/@/views/frontend/apply/member/preparers.vue'),
					// 	meta: {
					// 		title: '人员管理',
					// 	},
					// },
					// {
					// 	path: 'subAccount',
					// 	name: 'subAccount',
					// 	component: () => import('/@/views/frontend/apply/member/subAccount.vue'),
					// 	meta: {
					// 		title: '子账号管理',
					// 	},
					// },
					// {
					// 	path: 'private',
					// 	name: 'private',
					// 	component: () => import('/@/views/frontend/apply/member/private.vue'),
					// 	meta: {
					// 		title: '私有化配置',
					// 	},
					// },
					{
						path: 'callForBids',
						name: 'callForBids',
						component: () => import('/@/views/frontend/apply/member/callForBids.vue'),
						meta: {
							title: '招标解析记录',
						},
					},
					{
						path: 'castMarkDocument',
						name: 'castMarkDocument',
						component: () => import('/@/views/frontend/apply/member/castMarkDocument.vue'),
						meta: {
							title: '投标生成记录',
						},
					},
					// {
					// 	path: 'castMarkDocumentReview',
					// 	name: 'castMarkDocumentReview',
					// 	component: () => import('/@/views/frontend/apply/member/castMarkDocumentReview.vue'),
					// 	meta: {
					// 		title: '评分审查记录',
					// 	},
					// },
					// {
					// 	path: 'notice',
					// 	name: 'notice',
					// 	component: () => import('/@/views/frontend/apply/member/notice.vue'),
					// 	meta: {
					// 		title: '招标公告',
					// 	},
					// },
					{
						path: 'biddingAnnouncement',
						name: 'biddingAnnouncement',
						component: () => import('/@/views/frontend/apply/member/biddingAnnouncement.vue'),
						meta: {
							title: '招标公告',
						},
					},
					{
						path: 'accountManagement',
						name: 'accountManagement',
						component: () => import('/@/views/frontend/apply/member/accountManagement.vue'),
						meta: {
							title: '账号设置',
						},
					},
					// {
					// 	path: 'favorite',
					// 	name: 'favorite',
					// 	component: () => import('/@/views/frontend/apply/member/favorite.vue'),
					// 	meta: {
					// 		title: '收藏记录',
					// 	},
					// },
					{
						path: 'enterpriseManagement',
						name: 'enterpriseManagement',
						component: () => import('/@/views/frontend/apply/member/enterpriseManagement.vue'),
						meta: {
							title: '投标企业管理',
						},
					},
					{
						path: 'businessManagementDetails',
						name: 'businessManagementDetails',
						component: () => import('/@/views/frontend/apply/member/businessManagementDetails.vue'),
						meta: {
							title: '投标企业管理详情',
						},
					},
					{
						path: 'userDataset',
						name: 'userDataset',
						component: () => import('/@/views/frontend/apply/member/dataset.vue'),
						meta: {
							title: '查看分析招标文件',
						},
					},
					{
						path: 'gallery',
						name: 'gallery',
						component: () => import('/@/views/frontend/apply/member/gallery.vue'),
						meta: {
							title: '私有图库',
						},
					},
				]
			},
			{
				path: '/editpwd',
				name: 'editpwd',
				component: () => import('/@/views/frontend/apply/member/password.vue'),
				meta: {
					title: '修改密码',
				},
			},

			// {
			// 	path: '/test',
			// 	name: 'test',
			// 	component: () => import('/@/views/frontend/chat/test.vue'),
			// 	meta: {
			// 		title: 'test',
			// 	},
			// },

			// {
			// 	path: '/iframe',
			// 	name: 'iframe',
			// 	component: () => import('/@/views/frontend/chat/iframe.vue'),
			// 	meta: {
			// 		title: 'iframe',
			// 	},
			// },
		],
	},
	{
		// 管理员登录页 - 不放在 adminBaseRoute.children 因为登录页不需要使用后台的布局
		path: adminBaseRoutePath + '/login',
		name: 'adminLogin',
		component: () => import('/@/views/backend/login.vue'),
		meta: {
			title: pageTitle('adminLogin'),
		},
	},
	// {
	//     会员登录页
	//     path: memberCenterBaseRoutePath + '/login',
	//     name: 'userLogin',
	//     component: () => import('/@/views/frontend/user/login.vue'),
	//     meta: {
	//         title: pageTitle('userLogin'),
	//     },
	// },
	{
		path: '/:path(.*)*',
		redirect: '/404',
	},
	{
		// 404
		path: '/404',
		name: 'notFound',
		component: () => import('/@/views/common/error/404.vue'),
		meta: {
			title: pageTitle('notFound'), // 页面不存在
		},
	},
	{
		// 后台找不到页面了-可能是路由未加载上
		path: adminBaseRoutePath + ':path(.*)*',
		redirect: (to) => {
			return {
				name: 'adminMainLoading',
				params: {
					to: JSON.stringify({
						path: to.path,
						query: to.query,
					}),
				},
			}
		},
	},
	// {
	//     会员中心找不到页面了
	//     path: memberCenterBaseRoutePath + ':path(.*)*',
	//     redirect: (to) => {
	//         return {
	//             name: 'userMainLoading',
	//             params: {
	//                 to: JSON.stringify({
	//                     path: to.path,
	//                     query: to.query,
	//                 }),
	//             },
	//         }
	//     },
	// },
	{
		// 无权限访问
		path: '/401',
		name: 'noPower',
		component: () => import('/@/views/common/error/401.vue'),
		meta: {
			title: pageTitle('noPower'),
		},
	},
]

const staticFiles: Record<string, Record<string, RouteRecordRaw>> = import.meta.glob('./static/*.ts', { eager: true })
for (const key in staticFiles) {
	if (staticFiles[key].default) staticRoutes.push(staticFiles[key].default)
}

export default staticRoutes
